export function getAccessParams(getState: () => any) {
  const sharedAccess = getState().sharedAccess;
  const config = { headers: { Authorization: sharedAccess.token } };
  const options = {
    suppressAuth: true,
    suppressGlobalNotification: true
  };

  return {
    config,
    options
  };
}
